export type FilterInputValue = (string | number | boolean)[];

export interface PhotoCaptions {
    topLines: [string, string];
    bottomLines: [string, string];
}

export type UploadPhotoItem =
    | { kind: "url"; url: string }
    | { kind: "file"; file: File; uid: string };

export interface Maintenance {
    enabled: boolean;
    message?: string;
    endsAt: string;
    startsAt: string;
}

export enum Theme {
    LIGHT = "light",
    DARK = "dark",
}
